import Axios from '@/plugins/axios'
import { onlineUrl,payUrl } from '@/utils/config';

/********************   实名认证相关  ****************************/ 
// 实名认证
export function goRealName(){
   return Axios({
      url: payUrl + '/pay/esign/org/auth',
      method: 'POST',
   })
}
// 查询是否认证(认证状态)
export function findIsAuthentication(data) {
  return Axios({
      method: 'POST',
      url: payUrl + '/pay/esign/org/auth/find',
      data,
  })
}


// 协议库列表
export function agreementList(data) {
  return Axios({
      method: 'POST',
      // url: '/need2/mk-leads/supplier/partner/agreement/list',
      url: '/mk-leads/supplier/partner/agreement/list',
      data,
  })
}

// 获取协议详情
export function getAgreementDetail(data) {
  return Axios({
      method: 'POST',
      // url: '/need2/mk-leads/supplier/partner/agreement/detail',
      url: '/mk-leads/supplier/partner/agreement/detail',
      data,
  })
}
// 协议授权
export function agreementAuthorization(data) {
  return Axios({
      method: 'POST',
      // url: '/need2/mk-leads/supplier/partner/agreement/authorization',
      url: '/mk-leads/supplier/partner/agreement/authorization',
      data,
  })
}
// 发起协议签署
export function sendAgreement(data) {
  return Axios({
      method: 'POST',
      // url: '/need2/mk-leads/supplier/partner/agreement/initiate-signing',
      url: '/mk-leads/supplier/partner/agreement/initiate-signing',
      data,
  })
}
// 预览协议
export function previewAgreement(data) {
  return Axios({
      method: 'POST',
      // url: '/need2/mk-leads/supplier/partner/agreement/preview',
      url: '/mk-leads/supplier/partner/agreement/preview',
      data,
  })
}
// 下载预览协议
export function downloadAgreement(previewId) {
  return Axios({
      method: 'GET',
      // url: `/need2/mk-leads/supplier/partner/agreement/preview-download/${previewId}`,
      url: `/mk-leads/supplier/partner/agreement/preview-download/${previewId}`,
  })
}

// 获取协议列表
export function getZhenYunAgreementListApi() {
  const config = {
    url: onlineUrl+'/biz-data/agreement/config-list',
    method: 'GET',
  }
  return Axios(config)
}


